import React from 'react';
import { theme } from 'antd';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { GlobalStyle } from '../../shared/styles/antd-theme';

export function StyleProvider({ children }: React.PropsWithChildren) {
  const { token } = theme.useToken();

  return (
    <StyledThemeProvider
      theme={{
        antd: token,
      }}
    >
      <GlobalStyle />
      {children}
    </StyledThemeProvider>
  );
}
